import React, { PureComponent } from 'react'
import { Table, Headers, Header, Body } from '../common/stylesheets/index'

class TableWrapper extends PureComponent {
  get headers() {
    return ['Field', 'Information Entered']
  }
  renderHeaders = () => {
    const { headers, props: { customHeaders } } = this
    const headerWidth = 100 / headers.length

    return (customHeaders || headers).map(header => (
      <Header key={`header-${header}`} width={headerWidth}>
        {header}
      </Header>
    ))
  }
  render () {
    const { children } = this.props

    return (
      <Table>
        <Headers>
          {this.renderHeaders()}
        </Headers>
        <Body>
          {children}
        </Body>
      </Table>
    )
  }
}

export default TableWrapper
